export const LRS_OBJECT_TYPES = {
	ATTENDANCE: 'attendance',
	ARCHIVED_EVENT: 'archived-event',
	CERTIFICATE: 'certificate',
	CHANNEL: 'channel',
	COMMENT: 'discussion-comment',
	DISCUSSION_COMMENT: 'discussion-comment',
	DISCUSSION_REPLY: 'discussion-reply',
	DISCUSSION_THREAD: 'discussion-thread',
	DISCUSSION_TOPIC: 'discussion-topic',
	EMBED: 'embed',
	EVENT: 'event',
	FORM: 'form',
	FORM_ENTRY: 'form-entry',
	IMAGE: 'image',
	LINK: 'link',
	MIRO: 'miro',
	MODULE: 'module',
	ORGANIZATION: 'organization',
	PAGE: 'page',
	PERMISSION: 'permission',
	POINT: 'point',
	POLL: 'poll',
	QUIZ: 'quiz',
	REPLY: 'discussion-reply',
	SESSION: 'session',
	SLIDE: 'slide',
	SUBMODULE: 'submodule',
	THREAD: 'discussion-thread',
	TOPIC: 'discussion-topic',
	USER: 'user',
	VIDEO: 'video',
	WORDPRESS_COMMENT: 'comment', // DEPRECATED
	WORDPRESS_GRAVITY_FORM: 'gravity-form', // DEPRECATED
	WORDPRESS_FORUM: 'forum', // DEPRECATED
	WORDPRESS_POST: 'post', // DEPRECATED
	WORDPRESS_REPLY: 'reply', // DEPRECATED
	WORDPRESS_TOPIC: 'topic', // DEPRECATED
};

export const LRS_ACTIONS = {
	ATTENDED: 'attended',
	CLICKED: 'clicked',
	COMPLETED: 'completed',
	CREATED: 'created',
	DELETED: 'deleted',
	EARNED: 'earned',
	ENDED: 'ended',
	FINISHED: 'finished',
	GRANTED: 'granted',
	MARKED_COMPLETE: 'marked-complete',
	MENTIONED: 'mentioned',
	PASSED: 'passed',
	PAUSED: 'paused',
	PLAYED: 'played',
	RSVPED: 'RSVPed',
	STARTED: 'started',
	UPDATED: 'updated',
	VIEWED: 'viewed',
};

/**
 * The object types for the events that can be triggered by our PubSub system.
 */
const EVENTS_TRIGGER_OBJECT = {
	COMPLETION_TRACKER: 'completion-tracker',
	CUSTOM_NOTIFICATION: 'custom-notification',
	EMAIL: 'email',
	ENROLLMENT: 'enrollment',
	EVENT: 'event',
	EVENT_STAGE: 'event-stage',
	FORM_ENTRY: 'form-entry',
	LIVE_STREAM: 'live-stream',
	LRS_STATEMENT: 'lrs-statement',
	NOTIFICATION: 'notification',
	POINT_LOG: 'point-log',
	RESOURCE: 'resource',
	USER: 'user',
	VIDEO: 'video',
};

/**
 * The action types for the events that can be triggered by our PubSub system.
 */
const EVENTS_TRIGGER_ACTION = {
	CREATE: 'create',
	QUEUE: 'queue',
	SEND: 'send',
	STARTING: 'starting',
	TEST: 'test',
	UPDATE: 'update',
};

/**
 * List of action:object combinations which can be used as
 * listeners in sockets for events sent by our PubSub system.
 */
export const SOCKET_LISTENER_EVENTS = {
	CREATE_LRS_STATEMENT: `${EVENTS_TRIGGER_ACTION.CREATE}:${EVENTS_TRIGGER_OBJECT.LRS_STATEMENT}`,
	CREATE_NOTIFICATION: `${EVENTS_TRIGGER_ACTION.CREATE}:${EVENTS_TRIGGER_OBJECT.NOTIFICATION}`,
	CREATE_POINT_LOG: `${EVENTS_TRIGGER_ACTION.CREATE}:${EVENTS_TRIGGER_OBJECT.POINT_LOG}`,
	CREATE_RESOURCE: `${EVENTS_TRIGGER_ACTION.CREATE}:${EVENTS_TRIGGER_OBJECT.RESOURCE}`,
	UPDATE_COMPLETION_TRACKER:
		`${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.COMPLETION_TRACKER}`,
	UPDATE_ENROLLMENT: `${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.ENROLLMENT}`,
	UPDATE_EVENT: `${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.EVENT}`,
	UPDATE_EVENT_STAGE: `${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.EVENT_STAGE}`,
	UPDATE_LIVE_STREAM: `${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.LIVE_STREAM}`,
	UPDATE_FORM_ENTRY: `${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.FORM_ENTRY}`,
	UPDATE_RESOURCE: `${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.RESOURCE}`,
	UPDATE_USER: `${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.USER}`,
	UPDATE_VIDEO: `${EVENTS_TRIGGER_ACTION.UPDATE}:${EVENTS_TRIGGER_OBJECT.VIDEO}`,
};
